import secondaryComponents from "../..";
import { GoalsRevenueImage } from "../../../../assets/svgImages";
import { DeleteGoalsPrompt } from "../DeleteGoalsPrompt";
import { useGoalsTable } from "./useGoalsTable";
import styles from "./styles.module.scss";

export const GoalsTable = ({
  goalsList = [],
  metaDetails = {},
  gotoPage = () => {},
}) => {
  const { instance, isDeleteGoal, setIsDeleteGoal } = useGoalsTable({
    goalsList,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        classNames={styles.goalsTable}
        hasAction={true}
      >
        <div className="text-center py-4">
          <GoalsRevenueImage />

          <h4 className=" mt-4">You have no Revenue goal set up</h4>
          <p>
            Use the button above to add a new revenue goal When you do, they
            would appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination section */}
      {goalsList?.length > 0 && (
        <secondaryComponents.Pagination
          totalPageNumber={metaDetails.last_page}
          handlePageClick={(value) => gotoPage(value?.selected + 1)}
          currentPage={metaDetails.current_page}
        />
      )}

      {/* delete goals prompt */}
      <DeleteGoalsPrompt
        isDeleteGoal={isDeleteGoal}
        setIsDeleteGoal={setIsDeleteGoal}
        closeModal={() => setIsDeleteGoal(null)}
      />
    </>
  );
};
